import React, { Fragment, useEffect, useState } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage'
import { ReorderStockSearch } from './ReorderStockSearch'
import { Filter } from '../../components/_WMS/FilterComponent'
import { defaultFilters } from './config'
import { useApi } from '../../hooks/useApi'
import { Stock } from './Entities/Stock'
import { ApiResponse } from '../../typings/ApiResponse'
import {
  GenericOrderBy,
  GenericTable,
  getNewDirection
} from '../../components/_EOS/Table'
import { getStockReserve } from './api'
import { Status } from '../../hooks/useFetchState'
import { usePagination } from '../../hooks/usePagination'
import { generateTableHeadersReorderStock } from '.'
import { useModal } from '../../hooks/useModal'
import { Modal } from '../../components/_EOS/Modal'
import { CreateRestockOrderModal } from './CreateRestockOrderModal'
import { useSnackbar } from '../../hooks/useSnackbar'
import { SnackBar } from '../../components/SnackBar/Snackbar'

interface RestockOrderPageProps {}

export const RestockOrderPage: React.FC<RestockOrderPageProps> = () => {
  const { isActive, isSuccess, message, openSnackBar } = useSnackbar()
  const [selectedFilters, setSelectedFilters] =
    React.useState<Filter[]>(defaultFilters)
  const [selectedElement, setSelectedElement] = React.useState<number[]>([])
  const { state, callApi } = useApi<ApiResponse<Stock>>()
  const [orderBy, setOrderBy] = useState<GenericOrderBy<Stock>>({
    field: '',
    direction: 'desc'
  })
  const pagination = usePagination(5)

  const tableHeadersReorderStock = generateTableHeadersReorderStock()

  const handleSorting = ({ field, direction }: GenericOrderBy<Stock>) => {
    const auxField = field
    if (auxField === orderBy.field) {
      const newDirection = getNewDirection(orderBy.direction)
      setOrderBy((_prev) => ({ field: auxField, direction: newDirection }))
      return
    }

    setOrderBy({ field, direction })
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page

    setSelectedElement([])

    requestStockReserve(selectedFilters, auxPage, pageSize)

    pagination.setPagination(auxPage, pageSize)
  }

  const requestStockReserve = (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => {
    callApi(getStockReserve(filters, page, pageSize, orderBy)).then(() =>
      setSelectedElement([])
    )
  }

  useEffect(() => {
    pagination.setPagination(0, pagination.pageSize)

    requestStockReserve(selectedFilters, 0, pagination.pageSize)
  }, [orderBy, selectedFilters])

  const createModalState = useModal('Crear Orden')

  return (
    <Fragment>
      <StandardPage
        pageTitle=''
      >
        {/* SEARCH */}
        <ReorderStockSearch
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          onSearchClick={requestStockReserve}
          onAddButtonClick={() => createModalState.openModal('md')}
          addButtonTitle='Crear'
          createButtonTooltip='Crear Reabastecimiento'
        />

        {/* TABLE */}
        <GenericTable<Stock>
          headersConfig={tableHeadersReorderStock}
          IDKey={'id'}
          data={state.data?.items}
          pagination={{
            totalItem: state.data?.totalItems || 0,
            page: pagination.page,
            pageSize: pagination.pageSize
          }}
          onPaginationChange={handlePaginationChange}
          isLoading={state.status === Status.Loading}
          checkedElements={selectedElement}
          onSortChange={handleSorting}
          orderField={orderBy}
        />
      </StandardPage>

      <Modal
        open={createModalState.isOpen}
        title={createModalState.title}
        maxWidth={createModalState.size}
        onClose={createModalState.closeModal}
        cancelButton={{
          action: createModalState.closeModal,
          title: 'Salir'
        }}
      >
        <CreateRestockOrderModal
          handleSnackbar={openSnackBar}
          handleCloseModal={createModalState.closeModal}
          requestRestockOrder={() => {
            requestStockReserve(
              selectedFilters,
              pagination.page,
              pagination.pageSize
            )
          }}
        />
      </Modal>
      {/* SNACKBAR */}
      <SnackBar
        message={message}
        open={isActive}
        status={isSuccess ? 'success' : 'error'}
      />
    </Fragment>
  )
}
